
import Mixins from '@/shared'

export default {
  name: 'StandingsTable',
  mixins: [Mixins],
  props: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    table: {
      type: Array,
      required: true,
      default: () => []
    },
    maxRows: {
      type: Number,
      required: false,
      default: null
    }
  },
  computed: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    displayTable (): any[] {
      const rows = this.table as any[]
      if (this.maxRows != null && this.maxRows > 0) {
        return rows.slice(0, this.maxRows)
      }
      return rows
    }
  }
}
